import { render, staticRenderFns } from "./ParameterV2.vue?vue&type=template&id=4de163a9&scoped=true&"
import script from "./ParameterV2.vue?vue&type=script&lang=js&"
export * from "./ParameterV2.vue?vue&type=script&lang=js&"
import style0 from "./ParameterV2.vue?vue&type=style&index=0&id=4de163a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de163a9",
  null
  
)

export default component.exports